"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const array_move_1 = require("../../utils/array-move");
const react_sortable_hoc_1 = require("react-sortable-hoc");
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox/Checkbox"));
const DragIndicator_1 = __importDefault(require("@material-ui/icons/DragIndicator"));
const dialog_1 = require("../../components/dialog/dialog");
const table_context_1 = require("./table-context");
/**
 * Column dialog.
 */
exports.TableColumnDialog = react_1.forwardRef(function TableColumnDialog(props, ref) {
    const { setColumnsState: setProvidedFiltersState, defaultColumnsState, columns, columnsState: providedColumnsState, classes, } = react_1.useContext(table_context_1.TableContext);
    const [columnsState, setColumnsState] = react_1.useState([]);
    /**
     * Toggles the visibility flag on selected column.
     */
    const toggleColumnVisibility = event_callback_hook_1.useEventCallback((datakey) => {
        setColumnsState((columnsState) => {
            const index = columnsState.findIndex((column) => column.datakey === datakey);
            if (index !== -1) {
                return [
                    ...columnsState.slice(0, index),
                    { ...columnsState[index], visible: !columnsState[index].visible },
                    ...columnsState.slice(index + 1),
                ];
            }
            else {
                return columnsState;
            }
        });
    });
    /**
     * Swaps column positions.
     */
    const swapColumns = event_callback_hook_1.useEventCallback(({ oldIndex, newIndex }) => {
        setColumnsState((columnsState) => array_move_1.arrayMove(columnsState, oldIndex, newIndex));
    });
    /**
     * Saves current column states.
     */
    const handleSave = event_callback_hook_1.useEventCallback(() => {
        setProvidedFiltersState(columnsState);
    });
    /**
     * Resets internal column state.
     */
    const handleShow = event_callback_hook_1.useEventCallback(() => {
        setColumnsState(providedColumnsState);
    });
    const handleReset = event_callback_hook_1.useEventCallback(() => {
        setColumnsState(defaultColumnsState);
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_COLUMN_DIALOG_TITLE", defaultMessage: "Nastaven\u00ED sloupc\u016F" }), confirmLabel: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_COLUMN_DIALOG_BTN_SAVE", defaultMessage: "Ulo\u017Eit" }), onConfirm: handleSave, onShow: handleShow, actions: [
            react_1.default.createElement(Button_1.default, { key: "removeAll", variant: "outlined", onClick: handleReset },
                react_1.default.createElement(Typography_1.default, { classes: { root: classes.buttonLabel } },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_COLUMN_DIALOG_BTN_RESET", defaultMessage: "Obnovit" }))),
        ] }, () => (react_1.default.createElement("div", null,
        react_1.default.createElement(SortableColumnList, { useDragHandle: true, lockAxis: "y", onSortEnd: swapColumns, columnsState: columnsState, columns: columns, onVisibleToggle: toggleColumnVisibility })))));
});
/**
 * Whole list of columns entries with sortable functionality.
 */
const SortableColumnList = react_sortable_hoc_1.SortableContainer(function SortableColumnList({ columnsState, columns, onVisibleToggle, }) {
    const { classes } = react_1.useContext(table_context_1.TableContext);
    return (react_1.default.createElement("ul", { className: classes.columnDialogList }, columnsState.map((state, i) => {
        const column = columns.find((column) => column.datakey === state.datakey);
        return (react_1.default.createElement(SortableColumnEntry, { key: state.datakey, index: i, column: column, columnState: state, onVisibleToggle: onVisibleToggle }));
    })));
});
/**
 * Draggable handle to change column order.
 */
const DragHandle = react_sortable_hoc_1.SortableHandle(({ className }) => (react_1.default.createElement(DragIndicator_1.default, { className: className })));
/**
 * One column entry with sortable functionality.
 */
const SortableColumnEntry = react_sortable_hoc_1.SortableElement(function ColumnEntry({ columnState, column, onVisibleToggle, }) {
    const { classes } = react_1.useContext(table_context_1.TableContext);
    return (react_1.default.createElement("li", { className: classes.columnDialogItem },
        react_1.default.createElement(DragHandle, { className: classes.columnDialogItemDraggable }),
        react_1.default.createElement(FormControlLabel_1.default, { className: classes.columnDialogItemLabel, classes: { label: classes.dialogCheckBoxLabel }, label: column.name, control: react_1.default.createElement(Checkbox_1.default, { disabled: column.fixed, checked: columnState.visible, color: "primary", onChange: () => onVisibleToggle(columnState.datakey) }) })));
});
//# sourceMappingURL=table-column-dialog.js.map